import * as z from "zod";

export const getCustomerStoreCreditBalance = {
  name: "getCustomerStoreCreditBalance" as const,
  input: z.object({ draftReturnId: z.string().optional() }),
  output: z.object({
    balance: z.number(),
    currencyCode: z.string().nullable(),
  }),
};

export type GetCustomerStoreCreditBalanceOutput = z.infer<
  typeof getCustomerStoreCreditBalance.output
>;
